import React, { useReducer, useEffect } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import AppContext from "./contexts/AppContext";
import reducer from "./reducers";

import Amplify, { I18n } from "aws-amplify";
import awsmobile from "./aws-exports";
import {
  AmplifyAuthenticator,
  AmplifySignUp,
  AmplifySignIn,
} from "@aws-amplify/ui-react";
import { Auth, Hub } from "aws-amplify";
import { AuthState } from "@aws-amplify/ui-components";
import amplifyTranslation from "./locales/ja/amplifyTranslation";

import DefaultLayout from "./layouts/default_layout";

import CssBaseline from "@material-ui/core/CssBaseline";

import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./assets/theme/theme";

// Amplifyの設定を行う
Amplify.configure(awsmobile);

const APP_KEY = "RedmineAppCurrent";

I18n.setLanguage("ja");
I18n.putVocabularies(amplifyTranslation);

const App = () => {
  const appState = localStorage.getItem(APP_KEY);
  // FIXME: 初期化の修正が必要。詳細はissuesの39507を確認。
  const current = appState ? JSON.parse(appState) : {};
  const initialState = {
    navbar: {},
    projects: [],
    // bookmarks: [],
    projectDetail: {},
    issues: {},
    issueDetail: {},
    search: {},
    siteConfigs: [],
    editConfig: {},
    users: [],
    current: current,
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    localStorage.setItem(APP_KEY, JSON.stringify(state.current));
  }, [state]);

  // ログアウト状態時にサイドバーでRedmine/プロジェクト/チケットフィルターの操作をしてcurrentに変化があった場合
  useEffect(() => {
    async function getCurrentAuthenticatedUser() {
      const userInfo = await Auth.currentUserInfo();
      if (!userInfo) {
        await Auth.signOut();
      }
    }
    getCurrentAuthenticatedUser();
  }, [state.current, state.navbar]);

  return (
    <>
      <AmplifyAuthenticator>
        <AmplifySignUp
          headerText="Create a new account"
          slot="sign-up"
          // usernameAlias="email"
          formFields={[
            {
              type: "username",
              required: true,
            },
            {
              type: "email",
              required: true,
            },
            {
              type: "password",
              required: true,
            },
          ]}
        />
        <AmplifySignIn
          slot="sign-in"
          headerText="Sign in to your account"
          // hideSignUp={true}
        />

        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <AppContext.Provider value={{ state, dispatch }}>
            <BrowserRouter>
              <Switch>
                <Route
                  path="/"
                  render={(props) => <DefaultLayout {...props} />}
                />
              </Switch>
            </BrowserRouter>
          </AppContext.Provider>
        </MuiThemeProvider>
      </AmplifyAuthenticator>
    </>
  );
};

// Appコンポーネントをラップする
// export default withAuthenticator(App,{signUpConfig});
export default App;
